import { MutableRefObject } from 'react';

import type { TreeViewBaseItem } from '@mui/x-tree-view';

export enum RootNodesIds {
  CalendarBlocks = 'calendar-blocks',
  CurrentPractice = 'current-practice',
  CurrentPracticePreferences = 'current-practice-prefs',
  CurrentUser = 'current-user',
  CurrentUserPreferences = 'current-user-prefs',
  Features = 'configuration-sets',
  PrimaryUser = 'primary-user',
  PrimaryUserPreferences = 'primary-user-prefs',
  RollloutConfigs = 'rollout-configs',
  VisitTypes = 'vts',
  VisitTypesMemberships = 'vtms',
}

export type InspectorData = {
  //defaultDataTree: TreeNode[];
  dataTree: TreeNode[];
  filteredDataTree: TreeNode[];
};

export enum InspectorConsoleSource {
  ConsoleLog = 'console-log',
  GlobalError = 'global-error',
  Inspector = 'inspector',
  RTK = 'rtk',
  Toast = 'toast',
}

export type InspectorConsoleLine = {
  data?: object;
  message: string;
  messageValue?: unknown;
  source: InspectorConsoleSource;
  timestampISO?: string;
};

export type TreeItemType = {
  children?: TreeNode[];
  content?: React.ReactNode;
  icon?: React.ReactNode;
  iconColor?: string;
  id: string;
  label: string;
  textColor?: string;
  value?: unknown;
};

export type InspectorTabProps = {
  dataRef?: MutableRefObject<InspectorData | undefined>;
  dataTree: TreeNode[];
  isLoading: boolean;
  onSelectionChange: (item: TreeItemType) => void;
  search: string;
  isExpanded: boolean;
};

export type TreeNode = TreeViewBaseItem<TreeItemType>;
